// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getFirestore } from "firebase/firestore";
import { getAuth, GoogleAuthProvider } from "firebase/auth";

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyB35SEwZ1vm0uf-rwVcSPUABypEJZJ5038",
  authDomain: "bullbearly-c7f66.firebaseapp.com",
  projectId: "bullbearly-c7f66",
  storageBucket: "bullbearly-c7f66.firebasestorage.app",
  messagingSenderId: "391841998701",
  appId: "1:391841998701:web:82691f76ec533536105c64",
  measurementId: "G-ZZZ1G8L0FD"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
const db = getFirestore(app);
const auth = getAuth(app);
const googleProvider = new GoogleAuthProvider();

export { app, analytics, db, auth, googleProvider };
